// @flow
import React from 'react';
import getRoutes from './routes';
import App from './containers/App';

const mapRoutesForUse = (routes, jpApiClient, apolloClient, storeState) =>
  routes.map((item) => {
    const { path: itemPath, children, element, loader, action } = item;

    const Element = element;

    return {
      path: itemPath,
      element: element ? <Element /> : null,
      loader: loader
        ? ({ params, request }) =>
            loader({ params, request, jpApiClient, apolloClient, storeState })
        : null,
      action: action || (() => null),
      children: children && mapRoutesForUse(children)
    };
  });

export default (jpApiClient, apolloClient, storeState) => {
  const routes = getRoutes();
  const browserRoutes = mapRoutesForUse(
    routes,
    jpApiClient,
    apolloClient,
    storeState
  );

  return [
    {
      element: <App />,
      children: browserRoutes
    }
  ];
};
